import React, {Component} from 'react';
import swal from 'sweetalert';
import { Card, CardContent } from '@material-ui/core';
import { LineChart, CartesianGrid, XAxis, YAxis, Legend, Tooltip, Line } from 'recharts';
import $ from 'jquery';
import moment from 'moment';
import WaitingModal from '../generics/WaitingModal';

var Config = require('../../config');

class EquipmentTemperature extends Component{
    constructor(props){
        super(props);

        this.handleChange = this.handleChange.bind(this);
        this.onSearch = this.onSearch.bind(this);
        this.isValidForm = this.isValidForm.bind(this);
		this.showCtrlError = this.showCtrlError.bind(this);
        this.dateCompare = this.dateCompare.bind(this);
        this.printPDF = this.printPDF.bind(this);

        this.state = {
            graphics: [],
            start_date:"",
            end_date:"",
            max_date:""
        };
    }

    componentDidMount(){
        fetch(Config.default.apiGateway.URL+'offers?option=date',{ 
		    method: 'get',
		    headers: new Headers({
		       'Authorization': 'Bearer ' + sessionStorage.getItem("token") , 
		       'Accept': 'application/json',
		        'Content-Type': 'application/json',
		    })
		})
		.then(response => response.json())
		.then(response => {
			var aux = response.split('|');
			var date = aux[0].split("/");
            
            var start_date = moment(date[2]+'-'+date[1]+'-'+date[0]).subtract(30, 'days').format('YYYY-MM-DD');
            
			this.setState({
				start_date: start_date,
                end_date: date[2]+'-'+date[1]+'-'+date[0],
                max_date: date[2]+'-'+date[1]+'-'+date[0],
            });
            
            setTimeout(() => {
                this.onSearch();
            }, 300);
		})
    }

    handleChange(e){
        this.setState({[e.target.name]: e.target.value});
    }

    onSearch(e){
        if(e !== undefined) {e.preventDefault();}
        if(this.isValidForm()){
			if(this.dateCompare()){
                fetch(Config.default.apiGateway.URL+'equipment_temperature/stats?startDate='+this.state.start_date+
                    '&endDate='+this.state.end_date, {
                    method:'GET',
                    headers: new Headers({
                        'Authorization' : 'Bearer '+sessionStorage.getItem('token'),
                        'Accept'        : 'application/json',
                        'Content-Type'  : 'application/json'
                    })
                }).then(res => {
                    if(res.ok){
                        return res.json();
                    }else{
                        res.text().then(msg => {
                            swal('Error', msg, 'error');
                        });
                    }
                }).then(response => {
                    if(response !== undefined){
                        var graphics = [];
        
                        response.map((res)=>{
                            var obj = { 
                                id: res.equipmentId,
                                equipment: res.equipmentName, 
                                measurements:[]
                            };

                            res.measurements.map((m)=>{
                                return obj.measurements.push({
                                    date: moment(m.date).format('DD/MM/YYYY'),
                                    Min: m.minTemp,
                                    Max: m.maxTemp,
                                    Prom: m.averageTemp
                                });
                            })

                            return graphics.push(obj);
                        })
        
                        this.setState({graphics: graphics});
                    }
                });
            }else{
				swal('Error', 'La Fecha Hasta debe ser mayor o igual a Fecha Desde', 'error');
			}

		}else{
			swal('Error', 'Campos Incompletos', 'error');
		}
    }

    dateCompare(){
		var ini = moment(this.state.start_date);
		var fin = moment(this.state.end_date);
		var date_ok = true;

		if(ini !== 'Invalid date' && fin !== 'Invalid date'){
			if(fin < ini){
				date_ok = false;
				document.getElementById('end_date').classList.add('error');
			}else{
				document.getElementById('end_date').classList.remove('error');
			}
		}else{
			date_ok = false;
		}		

		return date_ok;
	}

	isValidForm() {
		const select = document.querySelector('form');
		const inputs = select.querySelectorAll('input, select');
	    let isFormValid = true;
	    
	    inputs.forEach(input => {
	    	if(input.required){
	    		
		      	const isInputValid = this.showCtrlError(input.name);
		      	if (!isInputValid) {
		        	isFormValid = false;
		    	}
		    	
		   
		  	}
	    });	    

	    return isFormValid;
	}

	showCtrlError(refName) {
		var res = null;
		var control = document.getElementById(refName);
		if (this.state[refName] === "") {

			if(control !== null){
				control.classList.add('error');
			}
			res = false;
		} else{
			if(control !== null){
				if(control.required && control.className.includes('error')){
					control.classList.remove('error');
				}
			}
			res = true;
		}
		

		return res;
	}

    async printPDF(id) {
        this.waiting_modal.handleShow('Imprimiendo...');

        var document = await fetch(Config.default.apiGateway.URL+'equipment_temperature/get_history?equipment_id='+id
            +'&start_date='+this.state.start_date+'&end_date='+this.state.end_date, {
			method : 'GET',
			responseType: 'blob', //Force to receive data in a Blob Format
			headers : new Headers({
				'Authorization': 'Bearer ' + sessionStorage.getItem("token"),
				'Content-Type': 'application/json'})
		})
		.then(res => {
			this.waiting_modal.handleClose();
			if(res.ok){
				
				return res.blob();
				
			}else{
				res.text().then(function(result) {
					swal('¡Error!', result, 'error');
					return;
				});
			}
		})
		.then(response => {
			if(response !== undefined){
				var fileURL = URL.createObjectURL(response);
                window.open(fileURL);
				return response;
			}
		});
    }

    render(){
        return (
            <div className="col-xs-12">
                <div className="route">
                    <h5 className="title_page">
                    {sessionStorage.getItem('health_facilities_name')} ->
                    {"Control de Calidad -> Temperatura de Equipos"}
                    </h5>
                </div>
                <div className="form-group">
                    <div className="col-xs-12 from-group">
                        <form noValidate>
                            <div className="col-xs-12 col-sm-2">
                                <span className="span-min">Fecha desde</span>
                                <input type="date" className="form-control input-sm hour-input" name="start_date" id="start_date" 
                                    value={this.state.start_date} onChange={(e)=>this.handleChange(e)}
                                    max={this.state.max_date} />
                            </div>
                            <div className="col-xs-12 col-sm-2">
                                <span className="span-min">Fecha hasta</span>
                                <input type="date" className="form-control input-sm hour-input" name="end_date" id="end_date" 
                                    value={this.state.end_date} onChange={(e)=>this.handleChange(e)}
                                    max={this.state.max_date} />
                            </div>
                            <div className="col-xs-12 col-sm-1" style={{marginTop:20}}>
                                <button className="btn btn-info" onClick={(e)=>this.onSearch(e)}>Buscar</button>
                            </div>
                        </form>
                    </div>
                    <div className="col-xs-12 form-group temp-eq" style={{marginTop:'1%'}}>
                        {this.state.graphics.length > 0 &&
                            this.state.graphics.map((graph, i)=>
                                <Card variant="outlined" key={i} className="form-group">
                                    <CardContent className="">                           
                                        <div className="col-xs-12" style={{textAlign:'center'}}>
                                            <h3>{graph.equipment}</h3>
                                        </div>
                                        <div className="col-xs-12"style={{textAlign:'right'}}>
                                            <button className="btn btn-info" onClick={(e)=>this.printPDF(graph.id)}>PDF</button>
                                        </div>
                                        <div className="col-xs-12">
                                            <LineChart
                                                width={$('.temp-eq').width() - 100}
                                                height={300}
                                                data={graph.measurements}
                                                margin={{top:20, right:50, left:20, bottom:5}}
                                            >
                                                <CartesianGrid strokeDasharray="3 3" />
                                                <XAxis dataKey="date" padding={{left:20, right:30}} />
                                                <YAxis />
                                                <Legend />
                                                <Tooltip />
                                                <Line type="monotone" dataKey="Min" stroke="blue" />
                                                <Line type="monotone" dataKey="Prom" stroke="green" />
                                                <Line type="monotone" dataKey="Max" stroke="red" />
                                            </LineChart>
                                        </div>
                                        
                                    </CardContent>
                                </Card>
                            )                            
                        }
                    </div>
                </div>

                <WaitingModal {...this.props} onRef={ref => (this.waiting_modal = ref)}/>
            </div>
        )        
    }
}

export default EquipmentTemperature;